<script>
import axios from 'axios'
import ModalBus from '@/eventBus'
import Eye from '@/components/icons/Eye'
import EyeSlash from '@/components/icons/EyeSlash'

export default {
  components: {
    EyeSlash,
    Eye,
  },

  props: {
    countriesList: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      form: {
        firstname: window.Laravel.user?.firstname,
        lastname: window.Laravel.user?.lastname,
        password: '',
        password_confirmation: '',
        country: window.Laravel.user?.country,
        phone: window.Laravel.user?.phone,
      },

      passwordShow: false,
      sending: false,
      errors: undefined,
      successMessage: '',
      errorMessage: '',
    }
  },

  methods: {
    togglePasswordType() {
      this.passwordShow = !this.passwordShow
    },

    closePopup() {
      ModalBus.emit('close')
    },

    handleSubmit() {
      this.sending = true
      this.errorMessage = ''
      this.errors = undefined
      this.successMessage = ''

      axios
        .put(`/moi`, this.form)
        .then((response) => {
          this.successMessage = response.data.message
          this.sending = false

          window.Laravel.user = response.data.user

          setTimeout(() => {
            window.location.reload(true)
          }, 1000)
        })
        .catch((error) => {
          this.sending = false
          if (error.response.status === 422) {
            this.errors = error.response.data.errors || {}
          } else if (error.response.status === 500 || error.response.status === 401) {
            this.errorMessage = error.response.data.message
          }
        })
    },
  },
}
</script>

<template>
  <div class="h-full w-full overflow-y-auto bg-white lg:w-auto lg:rounded-xl">
    <div class="flex items-center justify-between border-b-2 border-light/25 p-5">
      <h3 class="font-poppins text-xl font-medium text-secondary md:mr-8">Modifier vos informations</h3>
      <button
        class="relative h-10 w-10 rounded-full bg-secondary focus:outline-none"
        @click="closePopup">
        <div
          class="absolute left-1/2 top-1/2 flex h-1/2 w-1/2 -translate-x-1/2 -translate-y-1/2 flex-col items-end justify-between">
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full rotate-45 rounded bg-white"></div>
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full -rotate-45 rounded bg-white"></div>
        </div>
      </button>
    </div>
    <form
      method="POST"
      @submit.prevent="handleSubmit">
      <div class="p-5">
        <div class="flex w-full items-center">
          <user class="h-4 w-4 text-primary" />
          <h3 class="ml-4 font-poppins text-xl font-medium">Informations personnelles</h3>
        </div>

        <div
          v-if="errorMessage"
          class="relative mb-3 mt-3 rounded-lg bg-red-100 px-3 py-3 text-sm text-red-700">
          {{ errorMessage }}
        </div>
        <div
          v-if="successMessage"
          class="relative mb-3 mt-3 rounded-lg bg-emerald-100 px-3 py-3 text-sm text-emerald-700">
          {{ successMessage }}
        </div>
        <div class="w-full">
          <div class="grid grid-cols-2 gap-x-4">
            <label class="form__label">
              <span>Nom :*</span>
              <input
                v-model="form.lastname"
                placeholder="Ex: Dupont"
                class="form__input bg-white"
                type="text" />
              <span
                v-if="errors && errors['lastname']"
                class="text-xs text-red-500"
                >{{ errors['lastname'][0] }}</span
              >
            </label>
            <label class="form__label">
              <span>Prénom :*</span>
              <input
                v-model="form.firstname"
                :placeholder="$t('account.edit.inputs.firstname.placeholder')"
                class="form__input bg-white"
                type="text" />
              <span
                v-if="errors && errors['firstname']"
                class="text-xs text-red-500"
                >{{ errors['firstname'][0] }}</span
              >
            </label>
          </div>

          <div class="grid grid-cols-2 gap-x-4">
            <label class="form__label">
              <span>Email :</span>
              <input
                :value="$root.user.email"
                disabled
                class="form__input bg-lightgray" />
            </label>
            <label class="form__label">
              <span>Téléphone :*</span>
              <input
                v-model="form.phone"
                placeholder="Ex : 02 99 12 34 56"
                class="form__input bg-white"
                type="phone" />
              <span
                v-if="errors && errors['phone']"
                class="text-xs text-red-500"
                >{{ errors['phone'][0] }}</span
              >
            </label>
          </div>

          <label class="form__label">
            <span>Pays de résidence :*</span>
            <select
              v-model="form.country"
              class="form__input bg-lightgray lg:bg-white">
              <option
                disabled
                :value="null">
                Sélectionner
              </option>
              <option
                v-for="country in countriesList"
                :key="country.value"
                :value="country.value">
                {{ country.label }}
              </option>
            </select>
            <span
              v-if="errors && errors['country']"
              class="text-xs text-red-500"
              >{{ errors['country'][0] }}</span
            >
          </label>
        </div>
      </div>

      <div class="bg-lightgray p-5">
        <div class="flex w-full items-center">
          <user class="h-4 w-4 text-primary" />
          <h3 class="ml-4 font-poppins text-xl font-medium">Mot de passe</h3>
        </div>

        <p class="font-sans text-sm font-light text-light">
          Laisser vide si vous ne souhaitez pas changer votre mot de passe.
        </p>

        <div class="grid grid-cols-2 gap-x-4">
          <label class="form__label">
            <span>Mot de passe :</span>
            <div class="relative mt-2 w-full">
              <input
                v-model="form.password"
                :type="passwordShow ? 'text' : 'password'"
                class="form__input mt-0 w-full bg-white"
                autocomplete="new-password" />
              <button
                class="absolute right-4 top-1/2 -translate-y-1/2 focus:cursor-pointer focus:outline-none"
                type="button"
                @click="togglePasswordType">
                <Eye
                  v-if="passwordShow"
                  class="h-auto w-6"></Eye>
                <EyeSlash
                  v-else
                  class="h-auto w-6"></EyeSlash>
              </button>
            </div>
            <span
              v-if="errors && errors['password']"
              class="text-xs text-red-500"
              >{{ errors['password'][0] }}</span
            >
          </label>
          <label class="form__label">
            <span>Confirmer le mot de passe :</span>
            <input
              v-model="form.password_confirmation"
              class="form__input w-full bg-white"
              type="password"
              autocomplete="new-password" />
            <span
              v-if="errors && errors['password_confirmation']"
              class="text-xs text-red-500"
              >{{ errors['password_confirmation'][0] }}</span
            >
          </label>
        </div>
      </div>

      <div class="p-5">
        <button
          :disabled="sending"
          class="btn w-full"
          type="submit">
          <i
            v-if="sending"
            class="fa fa-spinner animate-spin"></i>
          Modifier
        </button>
      </div>
    </form>
  </div>
</template>
